const SESSION_TOKEN_KEY = 'loadtms_session_token';

export const getSessionToken = () => window.localStorage.getItem(SESSION_TOKEN_KEY);

export const setSessionToken = (token) => {
    if (token) {
        window.localStorage.setItem(SESSION_TOKEN_KEY, token);
    }
};

export const clearSessionToken = () => {
    window.localStorage.removeItem(SESSION_TOKEN_KEY);
};

export const apiFetch = (url, options = {}) => {
    const token = getSessionToken();
    const headers = new Headers(options.headers || {});

    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }

    return fetch(url, {
        ...options,
        headers
    });
};
